{
  "Nul": 1,
  "Een": 2,
  "Twee": 4,
  "Drie": 8,
  "Vier": 16,
  "Vijf": 32,
  "Zes": 64,
  "Zeven": 128
}
